import { useCampaignsStore } from '@/stores/campaigns'
import type { NavigationGuardNext, RouteLocation } from 'vue-router'

const EXISTING_REFERRAL_DRAW_IDS = new Set([563, 608])

export function referralRedirectGuard(paramName: string) {
  return async (
    to: RouteLocation,
    _from: RouteLocation,
    next: NavigationGuardNext
  ) => {
    try {
      const campaignStore = useCampaignsStore()
      const referralValue = to.params[paramName] as string
      const [referralCode, idStr] = referralValue.split(/-(\d+)$/)
      const referralId = parseInt(idStr, 10)

      if (!referralCode || isNaN(referralId)) {
        return next({ name: 'home' })
      }

      const campaign = EXISTING_REFERRAL_DRAW_IDS.has(referralId)
        ? await campaignStore.fetchCampaignByDrawId(referralId)
        : await campaignStore.fetchCampaignByCampaignId(referralId)

      if (!campaign) {
        return next({ name: 'home' })
      }

      const referralListId = campaign.referral_list_id ?? campaign.list_id

      return next({
        name: 'campaign',
        params: { campaignCode: campaign.code },
        query: {
          r: referralCode,
          ...(referralListId ? { list_id: referralListId } : {}),
        },
      })
    } catch (error) {
      console.error('Referral redirect failed:', error)
      return next({ name: 'home' })
    }
  }
}
